import { render, staticRenderFns } from "./RelatorioProdutividade.vue?vue&type=template&id=087d0b30"
import script from "./RelatorioProdutividade.vue?vue&type=script&lang=js"
export * from "./RelatorioProdutividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports